"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
class Icon extends react_1.PureComponent {
    render() {
        const _a = this.props, { className } = _a, otherProps = __rest(_a, ["className"]);
        const cssClasses = `material-icons ${className || ''}`.trim();
        return (React.createElement("i", Object.assign({ className: cssClasses }, otherProps), this.props.name));
    }
}
exports.Icon = Icon;



//////////////////
// WEBPACK FOOTER
// ./src/components/Icon.tsx
// module id = 355
// module chunks = 0